function Home() {
  return (
    <div className="min-h-screen h-screen select-none flex flex-col bg-black text-white relative">
      <div className="flex w-full bg-black/25 relative z-10">
        <div className="container p-5 flex items-center w-full max-w-5xl mx-auto">
          <img src="/logo.png" alt="Evolve Logo" className="h-5" />
          <div className="font-bold ml-4 tracking-tight">EvolveMC</div>
          <div className="flex items-center gap-4 ml-auto">
            <a
              href="/discord"
              className="text-neutral-400 rounded text-sm hover:text-white hover:bg-white/20 hover:ring-[6px] px-2 py-0.5 ring-white/20 duration-150"
            >
              Discord
            </a>
            <a
              href="/brand"
              className="text-neutral-400 rounded text-sm hover:text-white hover:bg-white/20 hover:ring-[6px] px-2 py-0.5 ring-white/20 duration-150"
            >
              Assets
            </a>
          </div>
        </div>
      </div>
      <div className="flex-1 flex flex-col justify-center items-center relative z-10">
        <img
          className="w-auto h-14 px-5 animate-in-bottom object-contain"
          src="/brand-assets/project_logo2.png"
          alt="Project logo text"
        />
        <div className="container p-5 max-w-2xl min-h-[40%] mt-12 lg:mt-20">
          <div className="font-semibold text-xl lg:text-2xl p-2 tracking-tight rounded bg-black/20 w-fit backdrop-blur">
            <span className="font-bold">Community Create VII</span> geht in die
            siebte Runde!
          </div>
          <div className="font-normal text-sm lg:text-base gap-1.5 text-gray-200 flex flex-col p-2 rounded bg-black/20 mt-2 backdrop-blur">
            <p>
              Auch dieses Jahr haben wir wieder ein eigenes Modpack erstellt,
              mit der <b>Create-Mod als Fokus</b> und vielen Erweiterungen
              drumherum.
            </p>
            <p>
              Der Fokus liegt auf{" "}
              <b>Technik, Automatisierung, Zügen, Fabriken</b>, aber genauso auf{" "}
              <b>Kreativität, Bauen</b> und einer aktiven <b>Community</b>.
            </p>
            <p>
              Egal ob Create-Neuling oder Veteran: <b>Alle sind willkommen</b>.
            </p>
          </div>

          <div className="flex gap-3 mt-6">
            <a
              href="/discord"
              className="px-4 py-2 rounded bg-neutral-200 text-black font-semibold hover:bg-gray-300 transition-colors duration-150"
            >
              → Mitspielen
            </a>
            <a
              href="/discord"
              className="px-4 py-2 rounded bg-white/10 text-white font-medium hover:bg-white/20 backdrop-blur transition-colors duration-150"
            >
              Discord
            </a>
            <a
              href="/modrinth"
              className="px-4 py-2 rounded bg-white/10 text-white font-medium hover:bg-white/20 backdrop-blur transition-colors duration-150"
            >
              Modrinth
            </a>
          </div>
        </div>
      </div>

      <div
        className="absolute inset-0 w-full h-full z-[1] pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, transparent 10%, rgba(0,0,0,0.66) 100%)",
        }}
      ></div>

      <img
        className="absolute inset-0 w-full h-full object-cover brightness-50 z-0 blur-[2px]"
        style={{}}
        src="/background.png"
        alt="Background"
      />
    </div>
  );
}

export default Home;
